import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-standing-order-actions-dropdown',
  templateUrl: './standing-order-actions-dropdown.component.html',
  styleUrls: ['./standing-order-actions-dropdown.component.css']
})
export class StandingOrderActionsDropdownComponent implements OnInit {
  @Input() assign;

  @Output() openDetail = new EventEmitter<any>();
  @Output() openCloneModal = new EventEmitter<any>();
  @Output() cloneStandingOrder = new EventEmitter<any>();
  @Output() logs = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

}
